import { Card, CardBody, Table } from "reactstrap";
import { AuthorizedSign, ECommerce, Invoice } from "../../../../../constants";
import { dynamicImage } from "../../../../../utils";
import { InvoiceButtons } from "../common/InvoiceButtons";
import InvoiceContent from "./InvoiceContent";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceOrder from "./InvoiceOrder";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";
import { Image } from "../../../../../coreComponents/Image";

// This component displays Invoice 1 email template with details like header, content, order summary, and signature.
const Invoice1Container = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <div className="invoice-1">
        <Card>
          <CardBody>
            <Table className="table-wrapper" borderless>
              <tbody>
                <tr>
                  <InvoiceHeader />
                </tr>
                <tr>
                  <td>
                    <Image className="w-100" src={dynamicImage(`email-template/invoice-1/1.png`)} alt="background" />
                  </td>
                </tr>
                <tr>
                  <InvoiceContent />
                </tr>
                <tr>
                  <InvoiceOrder />
                </tr>
              </tbody>
              <tbody>
                <tr className="signature-section">
                  <td>
                    <Image src={dynamicImage(`email-template/invoice-1/sign.png`)} alt="sign" />
                    <span className="signature-line" />
                    <span className="authorized-sign">{AuthorizedSign}</span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
      <InvoiceButtons />
    </>
  );
};

export default Invoice1Container;
